import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Sector } from "@modules/bookSectors/types";
import { SectorFormValues } from "@modules/bookSectors/validations";

import { editSectorService } from "./service";
import { UseEditSectorMutationOptions } from "./types";

export function useEditSectorMutation(
  options?: UseEditSectorMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Sector, ApiError, { id: string; data: SectorFormValues }>({
    mutationFn: ({ id, data }) => editSectorService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("book_sector_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
